(function () {
  'use strict';

  var BAR_SELECTOR = '#cbox .cb-box.cb-box__type-bar.cb-box__position-top';
  var HEADER_SELECTOR = '.section-header';
  var SPACER_ID = 'dgm-convertbox-sticky-spacer';
  var STYLE_ID = 'dgm-convertbox-sticky-offset-style';
  var ROOT_CLASS = 'dgm-convertbox-top-bar-visible';
  var HIDDEN_CLASS = 'dgm-convertbox-top-bar-hidden';
  var OFFSET_PROPERTY = '--dgm-convertbox-top-offset';
  var currentBar = null;
  var currentHeight = -1;
  var animationFrame = 0;
  var resizeObserver = null;
  var convertBoxObserver = null;
  var headerObserver = null;

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '#dgm-convertbox-sticky-spacer{display:block;width:100%;height:var(--dgm-convertbox-top-offset,0px);pointer-events:none;visibility:hidden;}' +
      'html.dgm-convertbox-top-bar-visible .shopify-section-header-sticky header{top:var(--dgm-convertbox-top-offset,0px);}' +
      'html.dgm-convertbox-top-bar-hidden .shopify-section-header-sticky header{top:0;}' +
      '#cbox .cb-box .cb-box__bg-color{display:block;}' +
      '#cbox .cb-box.cb-box__type-bar.cb-box__position-top{translate:0 0;transition:translate 500ms cubic-bezier(.03,.93,.97,1);}' +
      'html.dgm-convertbox-top-bar-hidden #cbox .cb-box.cb-box__type-bar.cb-box__position-top{translate:0 -100%;pointer-events:none;}' +
      '.card-wrapper--product .badge--sale{display:none!important;}';
    document.head.appendChild(style);
  }

  function getSpacer() {
    var spacer = document.getElementById(SPACER_ID);

    if (!spacer) {
      spacer = document.createElement('div');
      spacer.id = SPACER_ID;
      spacer.setAttribute('aria-hidden', 'true');
      spacer.hidden = true;
      document.body.insertBefore(spacer, document.body.firstChild);
    }

    return spacer;
  }

  function isRendered(bar) {
    if (!bar || !bar.isConnected || bar.hidden || bar.getAttribute('aria-hidden') === 'true') return false;

    var styles = window.getComputedStyle(bar);
    if (styles.display === 'none' || styles.visibility === 'hidden' || parseFloat(styles.opacity) === 0) return false;

    var rect = bar.getBoundingClientRect();
    var hiddenByScroll = document.documentElement.classList.contains(HIDDEN_CLASS);
    return rect.height > 0 && (hiddenByScroll || rect.bottom > 0);
  }

  function renderedHeight(bar) {
    return isRendered(bar) ? bar.getBoundingClientRect().height : 0;
  }

  function applyOffset(height) {
    if (height === currentHeight) return;

    currentHeight = height;
    document.documentElement.style.setProperty(OFFSET_PROPERTY, height + 'px');
    document.documentElement.classList.toggle(ROOT_CLASS, height > 0);

    var spacer = getSpacer();
    spacer.style.height = height + 'px';
    spacer.hidden = height === 0;
  }

  function observeConvertBox(bar) {
    if (resizeObserver) resizeObserver.disconnect();
    if (convertBoxObserver) convertBoxObserver.disconnect();

    currentBar = bar;
    resizeObserver = null;
    convertBoxObserver = null;

    if (!bar) return;

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleSync);
      resizeObserver.observe(bar);
    }

    var convertBoxRoot = document.getElementById('cbox') || bar;
    convertBoxObserver = new MutationObserver(scheduleSync);
    convertBoxObserver.observe(convertBoxRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
  }

  function syncHeaderVisibility() {
    var header = document.querySelector(HEADER_SELECTOR);
    var isHidden = Boolean(header && header.classList.contains('shopify-section-header-hidden'));
    document.documentElement.classList.toggle(HIDDEN_CLASS, isHidden);
  }

  function observeHeader() {
    if (headerObserver) headerObserver.disconnect();

    var header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;

    headerObserver = new MutationObserver(syncHeaderVisibility);
    headerObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
    syncHeaderVisibility();
  }

  function syncOffset() {
    animationFrame = 0;

    var bar = document.querySelector(BAR_SELECTOR);
    if (bar !== currentBar) observeConvertBox(bar);

    applyOffset(renderedHeight(bar));
  }

  function scheduleSync() {
    if (!animationFrame) animationFrame = window.requestAnimationFrame(syncOffset);
  }

  function initialize() {
    installStyles();
    getSpacer();
    observeHeader();

    var pageObserver = new MutationObserver(function () {
      scheduleSync();
      if (!headerObserver) observeHeader();
    });
    pageObserver.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('resize', scheduleSync, { passive: true });
    window.addEventListener('orientationchange', scheduleSync, { passive: true });
    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
